import queries from '@apis/queries';
import useToast from '@hooks/ui/useToast';
import { GiftBoxType } from '@models/gift';
import { useFlow } from '@router/stackflow';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

function useGiftBoxes(type: GiftBoxType, sorter: string) {
    const { data, status } = useQuery(queries.giftBox.list(type, sorter));
    const { pop } = useFlow();
    const toast = useToast();
    const { t } = useTranslation('gift');
    useEffect(() => {
        if (status === 'error') {
            toast.error(t('giftBox.loadError'));
            pop();
        }
    }, [status, pop, toast, t]);
    return data?.content;
}

export default useGiftBoxes;
